import React, { useEffect, useState } from "react";
import { updateEarthQuiz } from "../features/QuizContainer/QuizSlice";
import { useSelector, useDispatch } from 'react-redux';

const Navbar = ({ navbarPageData, loading, error, getNavbarDataReq }) => {
  const [isSticky, setIsSticky] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [searchText, setSearchText] = useState("");
  const disapatch = useDispatch();

  const onQuizClick = async (data) => {
    localStorage.setItem('quizPopup', data)
    await disapatch(updateEarthQuiz(data))
  }
  // const onQuizLinkClick = () => {
  //   disapatch(updateEarthQuiz(false))
  // }

  // Extract data from props with fallbacks
  const logoUrl =
    navbarPageData?.logoUrl ||
    "https://nexcorp.in/projects/bluediomondvoyage/html/images/logo.webp";
  // const menus = navbarPageData?.menus || [];

  const menus = [
    {
      label: "Services",
      href: "/services",
    },
    {
      label: "Experiences",
      href: "/experiences",
    },
    {
      label: "Destinations",
      href: "/destinations",
    },
    {
      label: "About",
      href: "/about",
    },
    {
      label: "Quiz",
      href: "/quiz",
    },
    {
      label: "Contact",
      href: "/contact",
    },
  ];

  const toggleSearch = () => {
    setShowSearch((prev) => !prev);
    setSearchText("");
  };

  const clearSearch = () => {
    setSearchText("");
  };
  useEffect(() => {
    if (getNavbarDataReq) {
      getNavbarDataReq();
    }
  }, [getNavbarDataReq]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="fixed-top">
      <div
        id="sticky-header"
        className={`nav-section ${isSticky ? "sticky" : ""}`}
      >
        <nav
          id="navbar_top"
          className="navbar navbar-expand-lg bg-light navbar-light"
        >
          <div className="container">
            <a className="navbar-brand" href="/">
              <img src={logoUrl} className="img-fluid logo-img" alt="logo" />
            </a>

            {/* Toggler */}
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="menuline bar1"></span>
              <span className="menuline bar2"></span>
              <span className="menuline bar3"></span>
            </button>

            {/* Navbar Links */}
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav">
                {/* Dropdowns */}
                {menus.map((menu, idx) => (
                  <li className="nav-item" key={idx}>
                    <a
                      className="nav-link"
                      href={menu.href}
                      role="button"
                      aria-expanded="false"
                      onClick={() => onQuizClick(false)}
                    >
                      {menu.label}
                    </a>
                  </li>
                ))}

                {/* Static Links */}
              </ul>

              {/* Right Menu */}
              <div className="nav-right-menu">
                <a href="/quiz" className="all-btn" onClick={() => onQuizClick(true)}>
                  Earth Quiz
                </a>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
